<template>
  <div id="app-mobile">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive == true" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: "mobile",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020/375;
#app-mobile {
  font-size: 16px * $zoom;
  // width: 380px * $zoom;
  display: flex;
  justify-content: center;
  // background-color: #f0f2f5;
}
</style>
